import React, { useContext, useEffect, useState } from "react";
import rightArrow from "../../assets/Stepper/right_arrow.svg";
import checkIcon from "../../assets/Stepper/checkIcon.png";
import "./style.scss";
import { Tooltip } from "antd";
import { BatchMarketPlaceContext } from "../../context/batchProvider";
import { useLocation } from "react-router-dom";

const Stepper = ({ activeStep, isSeggregation, isSeggAddOn }) => {
  const [selectedStep, setSelectedStep] = useState(1);
  const { batch_skipPages } = useContext(BatchMarketPlaceContext);
  const location = useLocation();
  const initialSteps = [
    { id: 1, title: "Upload Image", isCompleted: false, isActive: false },
    {
      id: 2,
      title: "Select MarketPlace",
      isCompleted: false,
      isActive: false,
    },
    { id: 3, title: "View Guidelines", isCompleted: false, isActive: false },
    { id: 4, title: "Add-On Services", isCompleted: false, isActive: false },
    {
      id: 5,
      title: "Confirm Upload Image",
      isCompleted: false,
      isActive: false,
    },
    { id: 6, title: "Review", isCompleted: false, isActive: false },
    { id: 7, title: "Order Summary", isCompleted: false, isActive: false },
  ];

  const initialSeggSteps = [
    { id: 1, title: "Select Variant", isCompleted: false, isActive: false },
    { id: 2, title: "Sequencing", isCompleted: false, isActive: false },
    { id: 3, title: "Mark Complete", isCompleted: false, isActive: false },
  ];

  const [steps, setSteps] = useState([]);

  const updateSteps = () => {
    const filteredSteps = initialSteps.filter((step) => {
      if (step.id === 3 && batch_skipPages.includes("viewGuidelines"))
        return false;
      if (step.id === 4 && batch_skipPages.includes("addOnService"))
        return false;
      return true;
    });
    const filteredSeggSteps = !isSeggAddOn
      ? initialSeggSteps
          .slice(0, -1)
          .map((step, index) =>
            index === 1
              ? { ...step, title: "Sequencing and Mark Complete" }
              : step
          )
      : initialSeggSteps;

    const updatedSteps = filteredSteps.map((step) => ({
      ...step,
      isActive: step.id === activeStep,
      isCompleted: step.id < activeStep,
      isDisabled: step.id > activeStep,
    }));
    const updatedSeggSteps = filteredSeggSteps.map((step) => ({
      ...step,
      isActive: step.id === activeStep,
      isCompleted: step.id < activeStep,
      isDisabled: step.id > activeStep,
    }));
    setSteps(!isSeggregation ? updatedSteps : updatedSeggSteps);
  };
  useEffect(() => {
    updateSteps();
  }, [activeStep, batch_skipPages, isSeggregation, location, isSeggAddOn]);

  return (
    <div className="stepper_section">
      <div
        className={`step_list ${
          selectedStep > 0 ? "selected_step_wrapper_" + selectedStep : ""
        }`}
      >
        {steps?.map((step, index) => {
          return (
            <>
              <div
                className={`step_wrapper ${
                  step.isActive
                    ? "active"
                    : step.isCompleted
                    ? "completed"
                    : step.isDisabled
                    ? "disabled"
                    : ""
                }`}
                key={`stepper${index}`}
              >
                <div className="step_number">
                  {step?.isCompleted ? (
                    <img src={checkIcon} alt="" />
                  ) : (
                    index + 1
                  )}
                </div>

                <div className="step_name">
                  {!step?.isActive ? (
                    <Tooltip title={step?.title} placement="bottom">
                      {step?.title?.slice(0, 4)}
                    </Tooltip>
                  ) : (
                    step?.title
                  )}
                </div>
              </div>
              <img src={rightArrow} alt="" />
            </>
          );
        })}
      </div>
    </div>
  );
};

export default Stepper;
